import { DiscountInfo } from '@/types/discount';
import { TFunction } from 'react-i18next';

export function sumDiscountAmounts(discounts?: DiscountInfo[]): number {
  return (discounts ?? []).reduce((s, d) => s + (d.amount ?? 0), 0);
}

export const buildDiscountSubtext = (lineItemDiscount: DiscountInfo, t: TFunction): string => {
  if (!lineItemDiscount) return '';

  const { percentageOff } = lineItemDiscount.discount;

  if (percentageOff !== undefined && percentageOff > 0) {
    return t('invoice.discountAmount', { amount: `${percentageOff}%` });
  }

  return '';
};

export const buildDiscountLabel = (lineItemDiscount: DiscountInfo, t: TFunction): string => {
  const subText = buildDiscountSubtext(lineItemDiscount, t);
  return lineItemDiscount.discount.name + (subText ? ` (${subText})` : '');
};
